import MyEvaluationDetailView from "../../features/performance/MyEvaluationDetailView";

const MyEvaluationDetailPage = () => <MyEvaluationDetailView />;

export default MyEvaluationDetailPage;
